import { Services } from '@Shared.Angular/@types/services';
import { BpmnModeler } from '@Shared.Angular/flowingly.bpmn.modeler/@types/services';
import { getInjector } from '@Shared.Angular/flowingly.helper/serviceInjector';
import { FlowModelGenerationFileService } from '@Shared.Angular/flowingly.services/flowModel.generationFile.service';

/**
 * Hook to get angularJs service via injector
 * @typedef T - type of the service
 * @param name
 * @returns T - the angularJs service
 * @deprecated Use `getService` instead.
 */
export const useService = <T>(name: SharedServiceName): T =>
  getInjector().get(name) as T;

export type SharedServiceTypeMap = {
  $location: angular.ILocationService;
  $q: angular.IQService;
  $state: angular.ui.IStateService;
  $window: angular.IWindowService;
  accountApiService: Services.AccountApiService;
  APP_CONFIG: Services.APP_CONFIG;
  appInsightsService: Services.AppInsightsService;
  avatarService: Services.AvatarService;
  BPMN_CONSTANTS: BpmnModeler.BpmnConstants;
  brandingService: Services.BrandingService;
  browserUtilsService: Services.BrowserUtilsService;
  categoryApiService: Services.CategoryApiService;
  dialogService: Services.DialogService;
  documentApiService: Services.DocumentApiService;
  commentApiService: Services.CommentApiService;
  fileService: Services.FileService;
  flowModelApiService: Services.FlowModelApiService;
  flowinglyApiService: Services.FlowinglyApiService;
  flowinglyConstants: Services.FlowinglyConstants;
  flowinglyDiagramService: Services.FlowinglyDiagramService;
  flowinglyMomentService: Services.FlowinglyMomentService;
  flowinglyModelUtilityService: Services.FlowinglyModelUtilityService;
  flowsUtilityService: Services.FlowsUtilityService;
  guidService: Services.GuidService;
  goService: GoJS;
  modelerApiService: Services.ModelerApiService;
  momentService: Moment;
  notificationService: Services.NotificationService;
  permissionsService: Services.PermissionsService;
  procedureApiService: Services.ProcedureApiService;
  pubsubService: Services.PubSubService;
  flowinglyMentionService: Services.FlowinglyMentionService;
  flowModelGenerationFileService: FlowModelGenerationFileService;
  sessionService: Services.SessionService;
  smartSelectService: Services.SmartSelectService;
  setupApiService: Services.SetupApiService;
  tagGroupApiService: Services.TagGroupApiService;
  teamApiService: Services.TeamApiService;
  tempModelerUrlService: Services.TempModelerUrlService;
  flowModelNodeSequenceService: Services.FlowModelNodeSequenceService;
  tokenService: Services.TokenService;
  validationService: Services.ValidationService;
  userApiService: Services.UserApiService;
  formThemesApiService: Services.FormThemesApiService;
  themeService: Services.ThemeService;
  [key: string]: unknown;
};

export const getService = <K extends SharedServiceName>(
  name: K
): SharedServiceTypeMap[K] =>
  getInjector().get(name) as SharedServiceTypeMap[K];
